import React, { useEffect } from "react";
import { Box, Divider, makeStyles, Typography } from "@material-ui/core";
import { ButtonLoader, IntroText } from "../../../components";
import { useHeader } from "../../../contexts";
import { useTranslation } from "react-i18next";
import { BRAND_GGT } from "../../../constants";

const useStyles = makeStyles({
  smallButton: {
    padding: "10px"
  }
});

const ScheduleHasInsurance = ({
  scheduleData,
  updateScheduleData,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();
  const classes = useStyles();

  useEffect(() => {
    setTitle(t("schedule.has_insurance.title"));
  }, []);

  const handleChange = hasInsurance => {
    updateScheduleData({ hasInsurance });
  };

  const isKansasTestLocation =
    scheduleData.locationState &&
    scheduleData.locationState.toUpperCase() === "KS" &&
    scheduleData.brand &&
    scheduleData.brand === BRAND_GGT;

  return (
    <Box data-cy="schedule-screen-has-insurance">
      <IntroText>{t("schedule.has_insurance.intro_text")}</IntroText>
      {isKansasTestLocation ? (
        <>
          <Typography paragraph>
            As part of the FFCRA and CARES Act, the federal government has
            mandated that insurers fully cover the costs of diagnostic COVID-19
            testing.
          </Typography>
          <Typography paragraph>
            Based on your reported symptoms and/or known contact with someone
            who has tested positive for COVID-19, this test may be eligible for
            coverage under insurance. While insurance is not required to
            proceed, providing your insurance information helps to expand
            testing access for other Kansans.
          </Typography>
          <Typography paragraph>
            No out-of-pocket cost or co-pay will be required.
          </Typography>
        </>
      ) : (
        <Typography paragraph align="center">
          {t("schedule.has_insurance.secondary_text")}
        </Typography>
      )}
      <ButtonLoader
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        data-cy="has-insurance-yes"
        onClick={() => handleChange(true)}
        loading={isSubmitting}
      >
        {t("schedule.has_insurance.options.yes")}
      </ButtonLoader>
      <Box my={2}>
        <Divider variant="middle" />
      </Box>
      <ButtonLoader
        variant="contained"
        color="default"
        fullWidth
        size="small"
        data-cy="has-insurance-no"
        onClick={() => handleChange(false)}
        loading={isSubmitting}
        className={classes.smallButton}
      >
        {t("schedule.has_insurance.options.no")}
      </ButtonLoader>
      {isKansasTestLocation && (
        <Box mt={2}>
          <ButtonLoader
            variant="contained"
            color="default"
            fullWidth
            size="small"
            data-cy="has-insurance-no-answer"
            onClick={() => handleChange(false)}
            loading={isSubmitting}
            className={classes.smallButton}
          >
            I prefer to not answer
          </ButtonLoader>
        </Box>
      )}
    </Box>
  );
};

export { ScheduleHasInsurance };
